import { CodeName, DateRange, Identifier, PolicyProvision } from '@heda/core-util';
import { PractitionerReference } from 'app/mdm/lib/practitioner/services/practitioner';

export class DigiluguReferral {
  public identifier: Identifier;
  public status: CodeName;
  public documentType: string;
  public creationTime: Date;
  public valid: DateRange;
  public patient: DigiluguReferralPatient;
  public authorDoctor: DigiluguReferralDoctor;
  public authorOrganization: DigiluguReferralOrganization;
  public priorityCode: string;
  public note: string;
  public reason: string;
  public referredService: CodeName;
  public referredSpeciality: CodeName;
  public referredDoctor: DigiluguReferralDoctor;
  public referredOrganization: DigiluguReferralOrganization;
  public diagnosis: DigiluguReferralDiagnosis;
  public anamnesis: string;
  public confidentiality: PolicyProvision[];
}

export class DigiluguReferralDiagnosis {
  public code: CodeName;
  public recurrence: CodeName;
  public text: string;
  public type: CodeName;
}

export class DigiluguReferralPatient {
  public nameGiven: string;
  public nameFamily: string;
  public identifier: Identifier;
}

export class DigiluguReferralDoctor {
  public nameGiven: string;
  public nameFamily: string;
  public medicalWorkerCode: string;
}

export class DigiluguReferralOrganization {
  public name: string;
  public code: string;
}

export class EConsultationSearchParams {
  public validFrom?: Date;
  public validTo?: Date;
  public status?: string;
}

export class EConsultationReferralResponse {
  public patientId: string;
  public type: CodeName;
  public decision: CodeName;
  public cancellationReason: CodeName;
  public comment: string;
  public additionalCommentDraft: string;
  public author: PractitionerReference;
  public diagnosis: {
    code: CodeName;
    designationNr: number;
    text: string;
    recurrence: CodeName;
  };
  public referralId: number;
  public policy: PolicyProvision[];
  public status: CodeName;
  public waitlistResponseId?: number;
}


export type EconResponseStatus = 'draft' | 'completed';

export const ECON_RESP_STATUS = {
  draft: 'draft' as EconResponseStatus,
  completed: 'completed' as EconResponseStatus
};

export class ReferralSearchParam {
  public document?: string;
  public patientIdentifier?: string;
  public patientId?: string;
  public code: string;
  public validFrom?: Date;
  public validTo?: Date;
}
